export enum HeaderTitle {
  ServicingProvider = "Servicing Provider",
  ReferringProvider = "Referring Provider",
  ServicingLocation = "Servicing Location",
  ReferringLocation = "Referring Location",
}
